import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserGalleryList } from './user-galary.dto';

export interface IResponseImageGallery {
    image: string
    user_id: number
    workspace_id: number
    updated_at: string
    created_at: string
    id: number
  }
  

@Injectable({
    providedIn: 'root'
})


export class UserGalleryService {

    constructor(private http: HttpClient) { }

    /**
     * Get all user`s image
     * @returns response
     */
    getUserGallery(page) {
        return this.http.get<UserGalleryList>(`galleries?page=${page}`);
    }

    /**
     * upload user image
     * @param formData
     * @returns response
     */
    uploadImage(formData: FormData) {
        return this.http.post<IResponseImageGallery>('galleries', formData);
    }

    /**
     * delete the gallery image
     * @param id 
     */
    deleteImage(id: number) {
        return this.http.delete(`galleries/${id}`);
    }

    /**
     * refresh the image if expire
     * @param id 
     */
    refreshImage(data) {
        return this.http.get(`temp-url`,{params:data});
    }

    /**
   * collect the form data from input file
   * @param files 
   */
    collectFormData(image) {
        const formData = new FormData();
        formData.append("image", image);
        return formData;
    }
}
